export default "__VITE_ASSET__CZdgB$$X__"